module.exports = __webpack_public_path__ + "static/media/life-insurance.09dd8149.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/life-insurance.svg
// module id = 980
// module chunks = 0